import React from 'react';
import { Bot, Code, LineChart, Brain } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Courses = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const courses = [
    {
      title: t.courses.fundamentals.title,
      description: t.courses.fundamentals.description,
      icon: Brain,
      link: '/cursos/fundamentos'
    },
    {
      title: t.courses.ml.title,
      description: t.courses.ml.description,
      icon: LineChart,
      link: '/cursos/machine-learning'
    },
    {
      title: t.courses.development.title,
      description: t.courses.development.description,
      icon: Code,
      link: '/cursos/desarrollo'
    },
    {
      title: t.courses.llm.title,
      description: t.courses.llm.description,
      icon: Bot,
      link: '/cursos/llms'
    }
  ];

  return (
    <section id="courses" className="py-20 bg-gradient-to-br from-cyan-50 via-white to-purple-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-4 bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
          {t.courses.title}
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12">
          {t.courses.subtitle}
        </p>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {courses.map((course, index) => (
            <a
              key={index}
              href={course.link}
              className="group p-6 rounded-xl border border-purple-100 hover:border-cyan-300 transition-all hover:shadow-lg bg-white/80 hover:bg-white cursor-pointer"
            >
              <course.icon className="w-10 h-10 text-cyan-600 group-hover:text-purple-600 transition-colors mb-4" />
              <h3 className="text-xl font-semibold mb-2 group-hover:text-purple-600 transition-colors">{course.title}</h3>
              <p className="text-gray-600">{course.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;